import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import Img from "gatsby-image"
import quoteTop from "../../images/icons/quoteTop.svg"
import quoteBottom from "../../images/icons/quoteBottom.svg"

const OpinionCard = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 12px 18px 0 rgba(0, 0, 0, 0.05), 0 4px 6px 0 rgba(0, 0, 0, 0.1);
  margin-bottom: 18px;
  & img,
  & .avatar {
    width: 48px;
    height: 48px;
  }
  & img.quote-bottom {
    display: none;
  }
  & .opinion {
    margin: 8px 0 16px;
    font-size: 16px;
    line-height: 25px;
    letter-spacing: 0.3px;
    font-family: "Made Light", sans-serif;
  }
  @media (min-width: 1024px) {
    width: calc(100% - 32px);
    margin: 0 auto;
    padding: 30px 0 50px;
    & .opinion {
      padding: 0 100px;
      font-size: 24px;
      line-height: 38px;
      margin: 0;
    }
    & img {
      width: 96px;
      height: 96px;
      object-fit: scale-down;
      &.quote-top {
        margin-left: 30px;
      }
    }
    & img.quote-bottom {
      display: flex;
      align-self: flex-end;
      margin-right: 30px;
    }
  }
`
const ClientContainer = styled.div`
  display: flex;
  align-items: center;
  & div {
    margin-left: 6px;
    & p:first-child {
      font-size: 20px;
      letter-spacing: 0.5px;
      font-family: "Made Bold", sans-serif;
      margin-bottom: 6px;
      line-height: normal;
    }
    & p:last-child {
      font-size: 16px;
      opacity: 0.6;
      line-height: normal;
      & a {
        text-decoration: none;
      }
    }
  }
  @media (min-width: 1024px) {
    padding-left: 100px;
    margin-top: -47px;
    & .avatar {
      width: 70px;
      height: 70px;
    }
    & div {
      margin-left: 16px;
      & p:first-child {
        font-size: 24px;
      }
      & p:last-child {
        font-size: 20px;
      }
    }
  }
`
const Opinion = ({ name, link, company, opinion, job, avatar }) => {
  return (
    <OpinionCard>
      <img
        src={quoteTop}
        alt="Cytat górny"
        title="Opinia klienta"
        className="quote-top"
      />
      <p className="opinion">{opinion}</p>
      <img
        src={quoteBottom}
        alt="Cytat dolny"
        title="Opinia klienta"
        className="quote-bottom"
      />
      <ClientContainer>
        <Img
          fluid={avatar.childImageSharp.fluid}
          alt="Zdjęcie klienta"
          title="Nasz klient"
          className="avatar"
          style={{ borderRadius: "50%" }}
        />
        <div>
          <p>{name}</p>
          <p>
            {job} w <a href={link}>{company}</a>
          </p>
        </div>
      </ClientContainer>
    </OpinionCard>
  )
}

export default Opinion

Opinion.propTypes = {
  name: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  company: PropTypes.string.isRequired,
  opinion: PropTypes.string.isRequired,
  job: PropTypes.string.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  avatar: PropTypes.object.isRequired,
}
